import type { IActivityReportState } from '@/store/modules/report/activity-report/types';

export const state: IActivityReportState = {
  activity: null,
};
